import gql from 'graphql-tag';

export default gql`
  fragment gmailThreadFragment on GmailThread {
    id
    uuid
  }
`;
